import { useState } from "react";
import { it } from "date-fns/locale";
import { CalendarBlank } from "@phosphor-icons/react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const pad = (n) => String(n).padStart(2, "0");
export const toLocalInput = (d) =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
const HOURS = Array.from({ length: 24 }, (_, i) => pad(i));
const MINUTES = Array.from({ length: 60 }, (_, i) => pad(i));

// Italian date (calendar) + 24h time picker. Value: "YYYY-MM-DDTHH:mm" local, "" = now.
export default function MovementDateField({ value, onChange, showHint = true, testid = "movement-date" }) {
  const [open, setOpen] = useState(false);
  const cur = value ? new Date(value) : null;
  const set = (date, hh, mm) => {
    const d = new Date(date);
    d.setHours(Number(hh), Number(mm), 0, 0);
    onChange(toLocalInput(d > new Date() ? new Date() : d));
  };
  const base = cur || new Date();
  const label = cur
    ? `${cur.toLocaleDateString("it-IT")} ${pad(cur.getHours())}:${pad(cur.getMinutes())}`
    : "Adesso (data e ora attuali)";
  return (
    <div className="block" data-testid={`${testid}-block`}>
      <span className="label-eyebrow block mb-2">Data e ora movimento</span>
      <div className="flex items-stretch gap-2">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button type="button" data-testid={testid} className="flex-1 flex items-center gap-2 border border-neutral-300 px-3 py-2 text-sm font-mono text-left hover:bg-neutral-50 transition-colors">
              <CalendarBlank size={16} className="text-neutral-400 shrink-0" /> {label}
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 z-[70]" align="start">
            <Calendar
              mode="single"
              locale={it}
              selected={cur || undefined}
              defaultMonth={base}
              disabled={{ after: new Date() }}
              toMonth={new Date()}
              onSelect={(d) => d && set(d, pad(base.getHours()), pad(base.getMinutes()))}
              data-testid={`${testid}-calendar`}
            />
          </PopoverContent>
        </Popover>
        <select data-testid={`${testid}-hour`} value={pad(base.getHours())} onChange={(e) => set(base, e.target.value, pad(base.getMinutes()))} className="px-2 border border-neutral-300 text-sm font-mono bg-white" aria-label="Ora">
          {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
        </select>
        <select data-testid={`${testid}-minute`} value={pad(base.getMinutes())} onChange={(e) => set(base, pad(base.getHours()), e.target.value)} className="px-2 border border-neutral-300 text-sm font-mono bg-white" aria-label="Minuti">
          {MINUTES.map((m) => <option key={m} value={m}>{m}</option>)}
        </select>
        {value && (
          <button type="button" data-testid={`${testid}-reset`} onClick={() => onChange("")} className="px-3 text-xs border border-neutral-300 hover:bg-neutral-50 transition-colors">
            Adesso
          </button>
        )}
      </div>
      {showHint && (
        <p className="text-xs text-neutral-500 mt-1" data-testid={`${testid}-hint`}>
          {value ? "Il movimento sarà registrato con questa data (non sono ammesse date future)." : "Lascia così per usare data e ora attuali."}
        </p>
      )}
    </div>
  );
}
